@if(showInscription) {
    <div class="all-container default">
        <div class="content-container default-content">
            <app-toolbar></app-toolbar>
            <router-outlet></router-outlet>
        </div>
    </div>
}
@else {
    <app-waiting-screen></app-waiting-screen>
}


